import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Grid from './Grid';
import { Plane, Pos } from './Types';

const press = ([x, y]: Pos) => (grid: Plane) => (
  grid.map((r, rx) => (
    Math.abs(rx - x) > 1 ? r : r.map((c, cy) => ((
      Math.abs(rx - x) + Math.abs(cy - y)) <= 1 ? !c : c))
  ))
);

const Page = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
`;

const Next = styled.div`
  position: absolute;
  width: 100%;
  text-align: center;
`;

const Text = styled.div`
  font-family: 'Roboto';
  font-size: 1.5rem;
  margin: 1rem 0 .5rem;
`;

const makeGrid = (n: number) => Array(n).fill(Array(n).fill(false));

const BASE_GRID_SIZE = 3;

const App = () => {
  const [presses, setClicks] = useState(0);
  const [wins, setWins] = useState(0);
  const [grid, setGrid] = useState(makeGrid(BASE_GRID_SIZE));

  useEffect(() => {
    setClicks(0);
    setGrid(makeGrid(BASE_GRID_SIZE + wins));
  }, [wins]);

  useEffect(() => {
    const upHandler = ({ key }: any) => {
      if (key === 's') setGrid(grid.map(r => r.map(() => true)));
    }
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keyup', upHandler);
    };
  }, [grid]);

  const isComplete = grid.flat().every((x) => x);

  const handleClick = ([x, y]: Pos) => () => {
    if (!isComplete) {
      setClicks(presses + 1);
      setGrid(press([x, y])(grid));
    }
  };

  const onNext = () => setWins(wins + 1);

  return (
    <Page>
      <Wrapper>
        <Grid
          data={grid}
          isComplete={isComplete}
          onPress={handleClick}
        />
        {isComplete && (
          <Next>
            <Text>Completed in {presses} presses.</Text>
            <button type="button" onClick={onNext}>Next</button>
          </Next>
        )}
      </Wrapper>
    </Page>
  );
};

export default App;
